
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.185 15.292a.485.485 0 00.154.024.5.5 0 00.475-.346l.608-1.877a.5.5 0 10-.951-.308l-.608 1.878a.5.5 0 00.322.629zM10.315 8.708a.5.5 0 00-.629.322l-.608 1.877a.5.5 0 00.321.63.526.526 0 00.155.024.5.5 0 00.475-.346l.608-1.878a.5.5 0 00-.322-.629zM8.038 17.372l.169-.524a.5.5 0 00-.951-.307l-.168.518A3.562 3.562 0 006.5 17a3.543 3.543 0 101.538.372zM6.5 23A2.5 2.5 0 119 20.5 2.5 2.5 0 016.5 23z"}}),_c('path',{attrs:{"d":"M17.5 17a3.562 3.562 0 00-.588.059L13.538 6.628a3.5 3.5 0 10-3.076 0l-.169.524a.5.5 0 00.322.63.515.515 0 00.154.024.5.5 0 00.475-.346l.168-.519A3.562 3.562 0 0012 7a3.562 3.562 0 00.588-.059l3.374 10.431A3.474 3.474 0 1017.5 17zm-8-13.5A2.5 2.5 0 1112 6a2.5 2.5 0 01-2.5-2.5zm8 19.5a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z"}})])
          )
        }
      }
    